import React, { Fragment, useEffect } from 'react';

import { counterReducer, useCounterReducer, actionTypes  } from '../../hooks/useCounter';


const InputWithLRBtn = props => {
    const {
        inputData: {
            id,
            isInputRequired,
            outerClass,
            name,
            placeholder,
            type,
            value
        },
        inputActions: {
            handleFieldChange
        },
        label: {
            text,
            labelClasses
        },
        button : {
            btnLId,
            btnRId,
            lBtnText,
            rBtnText,
            minCounter,
            maxCounter,
            btnClasses
        }
    } = props;


    const [ { counter }, dispatch ] = useCounterReducer(
        counterReducer, 
        { counter: value, minCounter, maxCounter }
    );

    useEffect(() => {
        handleFieldChange(counter);
    },[ counter ]);

    const handleCounterClick = (...args) => {
        const [ event, action ] = args;
        event.preventDefault();
        dispatch(action);
    };

    return (
        <Fragment>
            <div className={`gi-component gi-${type} ${outerClass && outerClass.join(' ')}`}>
                <button
                    id={`left__${btnLId}`}
                    className={`${btnClasses && btnClasses} usa-button gi-button gi-button__primary btn--left`}
                    onClick={e => handleCounterClick(e, { type: actionTypes.DECREMENT })}
                    disabled={counter <= minCounter}
                >{lBtnText}
                </button>
                <label
                    htmlFor={id}
                    className={`gi-${type}-label ${labelClasses && labelClasses.join(' ')}`}
                    aria-label={isInputRequired}
                >
                    { text }
                </label>
                <input
                    id={id}
                    className={`gi-${type}-input`}
                    data-testid = { id }
                    name={name}
                    type="text"
                    value={counter}
                    aria-required={isInputRequired}
                    placeholder={placeholder}
                    onChange={e => handleCounterClick(e, { type: actionTypes.MANUAL, counter: e.target.value } )}
                />
                <button
                    id={`right__${btnRId}`}
                    className={`${btnClasses && btnClasses} usa-button gi-button gi-button__primary btn--right`}
                    onClick={e => handleCounterClick(e, { type: actionTypes.INCREMENT })}
                    disabled = {counter >= maxCounter}
                >{rBtnText}
                </button>
            </div>
        </Fragment>
    );
};
export default InputWithLRBtn;
